import * as React from 'react';
import { Navigate, useOutlet } from 'react-router-dom';
import { NotFound } from '../Layout/NotFound';
import { useAppDispatch, useAppSelector } from '../../Store/store';
import { setCurrentBankAccount, setCurrentCompany, setTaxNumber, taxNumberSelector } from '../../Store/paramsBagSlice';
import { useLazyGetBankAccountListQuery } from '../../Store/bankaccount';
import { isEntrepreneur } from '../../Model/Entrepreneur';
import { useLazyGetCompanyListQuery } from '../../Store/company';
import { tokenSelector, userSelector } from '../../Store/authSlice';
import { useCallback, useEffect } from 'react';
import { Spinner } from '../Layout/Spinner';

export const RedirectRoute = () => {
  const outlet = useOutlet();
  const token = useAppSelector(tokenSelector);
  const user = useAppSelector(userSelector);
  const taxNumber = useAppSelector(taxNumberSelector);
  const dispatch = useAppDispatch();

  const [getBankAccountList] = useLazyGetBankAccountListQuery();
  const [getCompanyList] = useLazyGetCompanyListQuery();

  const isEntr = isEntrepreneur(user);

  const companyStatus = isEntr && user?.companies?.filter((company) => company?.status === 'preRegistered')[0];

  const getCompanies = useCallback(
    async () => (isEntr ? user?.companies : await getCompanyList().unwrap()),
    [getCompanyList, isEntr, user?.companies]
  );

  useEffect(() => {
    if (taxNumber) {
      (async () => {
        const companies = await getCompanies();
        const company = companies?.filter((company) => company.taxNumber === taxNumber)[0];
        if (company) {
          dispatch(setCurrentCompany(company));
          const bankAccounts = await getBankAccountList({ _id: company?._id }).unwrap();
          if (bankAccounts && bankAccounts.length > 0) {
            dispatch(setCurrentBankAccount(bankAccounts[0]));
          }
          dispatch(setTaxNumber(undefined));
        }
      })();
    }
  }, [taxNumber, dispatch, getCompanies, getBankAccountList]);

  if (taxNumber) {
    return <Spinner />;
  }

  console.log(token, user);

  if (token && !user) {
    return <Navigate to={'/privacy'} />;
  }

  if (companyStatus) {
    return <Navigate to={'/confirm'} />;
  }

  if (!token) {
    return <NotFound />;
  }

  return <>{outlet}</>;
};
